module.exports = __webpack_public_path__ + "static/media/019.6f6fb10d.jpg";